<template functional>
    <a href="#"
       class="btn-circle"
       v-on:click="listeners.click && listeners.click()">
        <inline-svg v-if="props.icon" :src="props.icon"></inline-svg>
    </a>
</template>

<script>
export default {
    name: 'BtnCircle',
};
</script>
